import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTelegram, FaYoutube } from 'react-icons/fa';
import '../MotorradFooter.css';

const MotorradFooter = () => {
    return (
        <footer className="motorrad-footer2">
            <div className="footer-content">
                
                {/* Навигация */}
                <div className="footer-column">
                    <ul className="footer-list">
                        <li><Link to="/">Главная</Link></li>
                        <li><Link to="/moto_models">Модели</Link></li>
                        <li><Link to="/service-request">Владельцам</Link></li>
                        <li><Link to="/contacts">Контакты</Link></li>
                    </ul>
                </div>

                {/* Соцсети */}
                <div className="footer-column footer-social-column">
                    <div className="footer-socials">
                        <a href="https://www.instagram.com/bmwmotorraduz/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="https://t.me/bmwuzpa" target="_blank" rel="noopener noreferrer"><FaTelegram /></a>
                        <a href="https://www.youtube.com/@BMWUzbekistanPA" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                    </div>
                </div>

                {/* Копирайт */}
                <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} BMW Motorrad Uzbekistan. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
};

export default MotorradFooter;